import { useState, useEffect } from 'react'; 
import { Helmet } from "react-helmet-async"; 
import axios from 'axios'; 

import useDomain from '../service/DomainHook'; 
import DomainUtils from '../service/utils/DomainUtils'; 
import { config } from '../config'; 

const MetaConfiguration = () => { 
    const baseURL = `${config?.baseUrl}${config?.version}`; 
    const [ hasSubDomain ] = useDomain(); 

    const [gscContent, setGscContent] = useState(''); 
    const [pvContent, setPvContent] = useState(''); 


    useEffect(async () => { 
        let googleSearchConsoleContent = localStorage.getItem('googleSearchConsoleContent'); 

        if(!googleSearchConsoleContent) { 
            let api = `/googleSearchConsole?adminType=SA&limit=1`; 
            if (hasSubDomain) { 
                const [franchisee] = await DomainUtils(); 
                api = `/googleSearchConsole?adminType=CA&franchiseeId=${franchisee}&limit=1`; 
            } 
            axios({ 
                url: api, 
                method: 'get', 
                baseURL: baseURL 
            }) 
            .then(res => { 
                if (res.data?.data.length > 0) { 
                    setGscContent(res.data.data[0].content); 
                } 
            }) 
            .catch(err => console.log(err)) 
        }  
        else {  
            setGscContent(googleSearchConsoleContent); 
        } 
    }, []) 


    useEffect(async () => {
        let pinterestVerificationContent = localStorage.getItem('pinterestVerificationContent');

        if (!pinterestVerificationContent) {
            let api = `/pinterestVerification?adminType=SA&limit=1`;
            if (hasSubDomain) {
                const [franchisee] = await DomainUtils();
                api = `/pinterestVerification?adminType=CA&franchiseeId=${franchisee}&limit=1`
            }
            axios({ 
                url: api,
                method: 'get',
                baseURL: baseURL
            })
            .then(res => {
                if (res.data?.data.length > 0) {
                    setPvContent(res.data.data[0].content);
                }
            })
            .catch(err => console.log(err))
        }
        else {
            setPvContent(pinterestVerificationContent);
        }
    }, []) 

    return ( 
        <> 
            <Helmet> 
                {/* {console.log({gscContent, pvContent})}  */}
                { gscContent && <meta name="google-site-verification" content={gscContent} /> } 
                { pvContent && <meta name="p:domain_verify" content={pvContent} /> } 

                <meta name="robots" content="noindex"></meta>
                <meta name="googlebot" content="noindex" ></meta>
            </Helmet> 
        </> 
    ); 
}; 

export default MetaConfiguration; 
